import isPropValid from '@emotion/is-prop-valid';
import React from 'react';
import { StyleSheetManager } from 'styled-components';

const ForwardPropProvider = ({ children }) => {
    const shouldForwardProp = (propName, target) => {
        if (typeof target === 'string') {
            return isPropValid(propName);
        }
        return true;
    };
    return React.createElement(StyleSheetManager, { shouldForwardProp: shouldForwardProp }, children);
};

export { ForwardPropProvider as default };
//# sourceMappingURL=ForwardPropProvider.mjs.map
